export default __webpack_public_path__ + "static/media/User.b2ac8607.svg";